import { ContentSubtypeAction  } from '../types/ContentSubTypeAction';
import { ContentSubType } from '../types/ContentSubTypeBody';


interface contentSubTypeState {
    list: ContentSubType[],
    error: string | "",
  };
  
  const initialState: contentSubTypeState = {
    list: [],
    error: "",
  };


const contentSubTypeReducer = (state = initialState, action: ContentSubtypeAction) => {
    switch (action.type) {
      case 'contentSubType_SUCCESS': {
        return { ...state, list: action.data }
      }
      case 'contentSubType_FAILED': {
        return { ...state, error: action.data }
      }
      default:
        return state;
    }
  }


export default contentSubTypeReducer;